import { render, staticRenderFns } from "./AgbEditor.vue?vue&type=template&id=ac2b562e&scoped=true&"
import script from "./AgbEditor.vue?vue&type=script&lang=js&"
export * from "./AgbEditor.vue?vue&type=script&lang=js&"
import style0 from "./AgbEditor.vue?vue&type=style&index=0&id=ac2b562e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2b562e",
  null
  
)

export default component.exports